<template>
  <div class="mt-4">
    <h4>{{$t("message.tableDetails")}}</h4>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label class="required" for="TableNumber">{{ $t('message.tableNumber') }}</label>
        <input
          v-if="!isAmadeous"
          v-validate="'required'"
          id="TableNumber"
          v-model="editModel.TableNumber"
          name="tableNumber"
          type="text"
          class="form-control"
        />
        <input
          v-else
          readonly="readonly"
          v-validate="'required'"
          id="TableNumber"
          v-model="editModel.TableNumber"
          name="tableNumber"
          type="text"
          class="form-control"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("tableNumber") | inputNameLocale("tableNumber")}}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6" v-if="showFirstNameFields">
        <label class="required" for="First Name">{{ $t('message.firstName') }}</label>
        <input
          v-validate="'required'"
          id="FirstName"
          v-model="editModel.FirstName"
          @change="syncFirstName(editModel.FirstName)"
          name="firstName"
          type="text"
          class="form-control"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("firstName") | inputNameLocale("firstName")}}</div>
      </div>
      <div class="form-group col-md-6" v-if="showLastNameFields">
        <label :class="{'required': !isAmadeous}" for="Last Name">
          {{ $t('message.lastName') }}
        </label>
        <input
          v-validate="isAmadeous ? '' : 'required'"
          id="LastName"
          v-model="editModel.LastName"
          name="lastName"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("lastName") | inputNameLocale("lastName")}}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12" v-if="ShowDineInPhoneNumber">
          <label :class="{'required': isDineInSMSEnabled}" for="Phone Number">{{ $t('message.phoneNumber') }}</label>
          <input
            v-validate="phoneValidationExpression"
            id="Phone Number"
            v-model="editModel.PhoneNumber"
            name="phoneNumber"
            type="text"
            class="form-control"
          />
          <div
          class="invalid-feedback"
          >{{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber")}}</div>
      </div>
    </div>

    <div class="form-row" v-if="showPayment && ((!user && viewConfig.LogIn) || !viewConfig.LogIn )">
      <div  class="form-group col-md-12"  v-show="shouldCollectEmail">
        <div>
        <label class="required" for="EmailAddress">{{ $t('message.emailAddress') }}</label>
        <input
          v-validate="'required|email'"
          @change="checkEmailExistance(editModel.Email)"
          @load="checkEmailExistance(editModel.Email)"
          @blur="checkEmailExistance(editModel.Email)"
          @keydown="userIsExist=false"
          id="EmailAddress"
          v-model="editModel.Email"
          name="emailAddress"
          type="email"
          class="form-control"
        />
        </div>
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("emailAddress") | inputNameLocale("emailAddress")}}</div>
      </div>
    </div>
    
    <div class="form-row" v-if="selectedCompany.DineInField">
      <div class="form-group col-md-12">
        <label for="DineInField">{{ selectedCompany.DineInField }}</label>
        <input
          id="DineInField"
          v-model="editModel.DineInField"
          name="DineInField"
          type="text"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="showPayment && (!user && viewConfig.LogIn)" class="form-row">
      <div class="form-group col-md-12">
        <div class="custom-control custom-checkbox col-md-12 ml-12">
          <input
            id="newAccount"
            type="checkbox"
            name="customCheckbox"
            :checked="createNewAccount"
            @change="check"
            class="custom-control-input"
            @input="val => $emit('save-user', val.target.checked)"
          />
          <label class="custom-control-label" for="newAccount">
            {{ $t('message.registerNewAccount') }}
            <small
              class="light-text d-block"
            >{{ $t('message.placingOrderAsGuest') }}</small>
          </label>
        </div>
      </div>
      <div class="form-group col-md-12" v-if="this.isBranded()">
        <div v-if="createNewAccount && userIsExist">
          {{ $t('message.alreadyAccountForEmail') }}
          <router-link
            class="text-primary"
            :to="{ name: 'login', params: { storeid: $parent.storeid ,forgift: forGift }}"
          >{{ $t('message.login') }}</router-link>&nbsp;here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { userIsExist } from "../../../../api/services/userService";
export default {
  name: "EatIn",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    isPayByCard : {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      userIsExist: false,
      createNewAccount: false
    };
  },
  computed: {
    ...mapGetters(["viewConfig", "getTotalPrice", "user","selectedCompany", "currentStoreDoc"]),
    isAmadeous() {
      if (this.$route.query.table || sessionStorage.getItem("table")) {
        return true;
      }
      return false;
    },
    isDineInSMSEnabled() {
      return this.selectedCompany.ViewComponentConfigs.DineInSMSconfirmation;
    },
    showPayment() {
      return this.$parent.showPayment;
    },
    showFirstNameFields() {
      return !!this.isDineInSMSEnabled
        || !this.isAmadeous
        || (this.isAmadeous && this.selectedCompany.ViewComponentConfigs.ShowDineInFirstLastName);
    },
    showLastNameFields() {
      return !this.isAmadeous
        || (this.isAmadeous && this.selectedCompany.ViewComponentConfigs.ShowDineInFirstLastName);
    },
    ShowDineInPhoneNumber() {
      return !!this.isDineInSMSEnabled 
        || !this.isAmadeous
        || (this.isAmadeous && this.selectedCompany.ViewComponentConfigs.ShowDineInPhoneNumber);
    },
    phoneValidationExpression() {
      let phoneValidations = { };
      if(this.isAmadeous) {
        phoneValidations = {...phoneValidations, min: 8, regex: this.getRegex(), max: this.getMax()}
      }
      if(this.isDineInSMSEnabled) {
        phoneValidations = {...phoneValidations, required: true}
      }
      return phoneValidations;
    },
    shouldCollectEmail(){
      if(this.isPayByCard){
        return true
      }
      return this.currentStoreDoc.PayLaterDisplayEmailEnabled
    },
  },
  mounted() {
    this.checkEmailExistance(this.editModel.Email);
  },
  methods: {
    getMax(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10:15
    },
    getRegex(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? /04\d{8}/:/\d/
    },
    syncFirstName(firstName) {
      if (this.$parent.syncFirstName) this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    checkEmailExistance(email) {
      userIsExist(email)
        .then(result => {
          if (result.length > 0) {
            this.$parent.setUserIsExist(true);
            this.userIsExist = true;
          } else {
            this.$parent.setUserIsExist(false);
            this.userIsExist = false;
          }
        })
        .catch(() => {
          this.$parent.setUserIsExist(false);
          this.userIsExist = false;
        });
    },
    check: function(event) {
      this.createNewAccount = event.target.checked;
    },
    setRegisterNewUserState(state) {
      this.createNewAccount = state;
    }
  }
};
</script>
